<template lang="pug">
  v-card.mx-auto(
    max-width="1200"
    flat
    color="transparent"
  )
    v-card.mx-auto(
      max-width="1200"
      flat
      color="transparent"
    )
      v-row.mb-0(align="center")
        v-col.d-flex(cols="12")
          v-text-field.headline(
            v-if="1===0"
            label="Название"
            full-width
            v-model="nameModel"
          )

      v-row.mb-0(align="center")
        v-col.d-flex(cols="12")
          v-text-field.headline(
            label="Текст"
            full-width
            v-model="textModel"
          )

      v-row.mb-0(align="center")
        v-col.d-flex(cols="12")
          v-text-field.headline(
            label="Ссылка"
            full-width
            v-model="linkModel"
          )

      v-row.mb-0(align="center") Можно загружать только картинки формата png, jpg. Рекомендованный размер: 745 x 110. Размер не более 1.2 MB
      v-row.mb-0(align="center")
        v-col.d-flex(cols="12")
          v-img(
            v-if="image!=='' && delImage===false"
            :src="image"
          )
        input(
          v-if="delImage===false"
          @change="onImageChanged($event)"
          accept="image/*"
          type="file"
        )
        v-checkbox.mt-0.pt-0(
          v-model="delImageModel"
          label="Удалить картинку"
          hide-details
          dense
        )

</template>

<script>

export default {
  props: {
    name: {
      type: String,
      default: null,
    },
    text: {
      type: String,
      default: null,
    },
    link: {
      type: String,
      default: null,
    },
    image: {
      type: String,
      default: null,
    },
    delImage: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onImageChanged(val) {
      this.$emit('imageChanged', val)
    },
  },
  computed: {
    nameModel: {
      get() {
        return this.name
      },

      set(val) {
        this.$emit('nameChanged', val)
      },
    },
    textModel: {
      get() {
        return this.text
      },

      set(val) {
        this.$emit('textChanged', val)
      },
    },
    linkModel: {
      get() {
        return this.link
      },

      set(val) {
        this.$emit('linkChanged', val)
      },
    },
    delImageModel: {
      get() {
        return this.delImage
      },

      set(val) {
        this.$emit('delImageChanged', val)
      },
    },
  },

}
</script>

<style lang="scss">
.ck-editor__editable_inline {
  min-height: 400px;
}
</style>
